import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router";
import { ApiError, errorMessage } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Alert, Button, Field } from "../components/ui";

// Pagina deschisă din emailul „Resetează parola”: /reset-password?token=…
export default function ResetPassword() {
  const { resetPassword } = useAuth();
  const nav = useNavigate();
  // Token-ul se citește o singură dată și dispare din bara de adrese și din istoric.
  const [token] = useState(() => new URLSearchParams(window.location.search).get("token") ?? "");
  useEffect(() => { history.replaceState(null, "", "/reset-password"); }, []);
  const [f, setF] = useState({ password: "", confirm: "" });
  const [error, setError] = useState<string>();
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (f.password !== f.confirm) return setError("Parolele nu coincid.");
    setBusy(true);
    setError(undefined);
    try {
      await resetPassword(token, f.password);
      nav("/", { replace: true });
    } catch (err) {
      setError(err instanceof ApiError && err.problem.code === "token_invalid"
        ? "Linkul nu mai este valabil (a expirat sau a fost deja folosit). Cere unul nou din pagina de autentificare."
        : errorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-indigo-50 to-white p-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <div className="text-sm font-bold uppercase tracking-[0.3em] text-brand">shopcore</div>
          <h1 className="mt-2 text-2xl font-bold">Alege o parolă nouă</h1>
        </div>
        {!token ? (
          <div className="card space-y-4 p-6 text-sm">
            <Alert>Linkul nu este complet.</Alert>
            <Link to="/login" className="font-semibold text-brand">Înapoi la autentificare</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="card space-y-4 p-6">
            <Field label="Parolă nouă" hint="Minim 10 caractere">
              <input className="input" type="password" required minLength={10} autoComplete="new-password" autoFocus
                value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} />
            </Field>
            <Field label="Repetă parola">
              <input className="input" type="password" required minLength={10} autoComplete="new-password"
                value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} />
            </Field>
            {error && <Alert>{error}</Alert>}
            <Button className="w-full" disabled={busy}>{busy ? "Se salvează…" : "Salvează parola"}</Button>
            <p className="text-xs text-slate-500">După salvare, toate sesiunile deschise anterior sunt închise.</p>
          </form>
        )}
      </div>
    </div>
  );
}
